import actions from '../../lib/api/actions';

export async function fetchAll({ commit }) {
  const response = await actions.fetchCategories();

  if (response.status === 200) {
    commit('setCategories', response.data);
  }
}

export async function fetchByCategoryId({ commit }, payload) {
  const response = await actions.fetchCategoryById(payload);

  if (response.status === 200) {
    commit('setCategories', response.data);
  }
}

export async function fetchProductById(context, productId) {
  const response = await actions.fetchProductById(productId);

  if (response.status === 200) {
    return response.data;
  }

  return null;
}

export async function initializeRootCategory({ commit, getters }, { categoryId }) {
  commit('setRootCategory', getters.findCategory(categoryId));
}

export async function setCurrentCategory({ commit }, payload) {
  commit('setCurrentCategory', payload);
}

export async function setCurrentProduct({ commit }, payload) {
  commit('setCurrentProduct', payload);
}

export async function setFilterForCurrentCategory({ commit }, payload) {
  commit('setFilterForCurrentCategory', payload);
}

export async function setSelectedFilter({ commit }, payload) {
  commit('setSelectedFilter', payload);
}
